import React from 'react';
import logoAvatar from './logo-avatar.png';

/**
 * FTLoading — the shell's fun waiting moment as a standalone component, for
 * surfaces that can't lean on the .ft-loading CSS atom (MUI/styled pages
 * like the trade canvas and the simulator). Pulsing Fantasy Taco mark with
 * an optional label underneath.
 */

const PING_CSS = `
@keyframes ft-cping {
  0% { box-shadow: 0 0 0 0 rgba(255, 122, 0, .30); transform: scale(1); }
  50% { transform: scale(1.06); }
  75% { box-shadow: 0 0 0 16px rgba(255, 122, 0, 0); }
  100% { box-shadow: 0 0 0 0 rgba(255, 122, 0, 0); transform: scale(1); }
}
`;

export const FTLoading = ({ label, size = 44, style }) => (
  <div
    style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      gap: 16, padding: '72px 0', textAlign: 'center',
      color: 'var(--ft-ink-3, #86868B)', fontSize: 14,
      ...style,
    }}
  >
    <style>{PING_CSS}</style>
    <img
      src={logoAvatar}
      alt=""
      style={{ width: size, height: size, borderRadius: '50%', animation: 'ft-cping 1.6s cubic-bezier(0.16, 1, 0.3, 1) infinite' }}
    />
    {label ? <div>{label}</div> : null}
  </div>
);

export default FTLoading;
